import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    platform: [
      { label: "Main Feed", path: "/main-feed" },
      { label: "Create Post", path: "/create-post" },
      { label: "Community Guidelines", path: "#" }
    ],
    support: [
      { label: "Help Center", path: "#" },
      { label: "Safety Tips", path: "#" },
      { label: "Report Issue", path: "#" }
    ],
    legal: [
      { label: "Privacy Policy", path: "#" },
      { label: "Terms of Service", path: "#" },
      { label: "Cookie Policy", path: "#" }
    ]
  };

  return (
    <footer className="bg-card border-t border-border py-10 md:py-12 lg:py-16 px-4 md:px-6 lg:px-8">
      <div className="container mx-auto max-w-6xl">
        {/* Main footer content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 lg:gap-12 mb-8 md:mb-10 lg:mb-12">
          {/* Brand section */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
                <Icon 
                  name="Heart" 
                  size={24} 
                  color="var(--color-primary)" 
                  strokeWidth={2}
                />
              </div>
              <div>
                <h3 className="text-lg font-heading font-semibold text-foreground">
                  OnlyCuts
                </h3>
                <p className="caption text-muted-foreground -mt-1">
                  Safe space for support
                </p>
              </div>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              A judgment-free platform for sharing emotional struggles and receiving supportive reactions from peers who understand.
            </p>
          </div>

          {/* Platform links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground mb-4">Platform</h4>
            <ul className="space-y-3">
              {footerLinks?.platform?.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link?.path}
                    className="text-sm text-muted-foreground hover:text-primary transition-therapeutic"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground mb-4">Support</h4>
            <ul className="space-y-3">
              {footerLinks?.support?.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link?.path}
                    className="text-sm text-muted-foreground hover:text-primary transition-therapeutic"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground mb-4">Legal</h4>
            <ul className="space-y-3">
              {footerLinks?.legal?.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link?.path}
                    className="text-sm text-muted-foreground hover:text-primary transition-therapeutic"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-muted-foreground text-center md:text-left">
              &copy; {currentYear} OnlyCuts. All rights reserved.
            </p>
            
            <div className="flex items-center gap-6">
              <a
                href="#"
                className="text-muted-foreground hover:text-primary transition-therapeutic"
                aria-label="Twitter"
              >
                <Icon name="Twitter" size={20} strokeWidth={2} />
              </a>
              <a
                href="#"
                className="text-muted-foreground hover:text-primary transition-therapeutic"
                aria-label="Facebook"
              >
                <Icon name="Facebook" size={20} strokeWidth={2} />
              </a>
              <a
                href="#"
                className="text-muted-foreground hover:text-primary transition-therapeutic"
                aria-label="Instagram"
              >
                <Icon name="Instagram" size={20} strokeWidth={2} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;